<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户编号</label>
            <span class="weui-form-preview__value">{{initData.cu_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户名称</label>
            <span class="weui-form-preview__value">{{initData.cu_name}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">业务员</label>
            <span class="weui-form-preview__value">{{initData.cu_sellername}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">收款方式</label>
            <span class="weui-form-preview__value">{{initData.cu_payments}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">币种</label>
            <span class="weui-form-preview__value">{{initData.sl_currency}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">合计</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.amount}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">当月</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.amount1}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">2~3个月</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.amount2}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">4~6个月</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.amount3}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">7~12个月</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.amount4}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">1-2年</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.amount5}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">2年以上</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.amount6}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initData: Object
  }
};
</script>